<template>
  <div>
    <!-- Container-fluid starts-->
    <div
      v-if="activeCompany"
      class="container"
    >
      <div class="page-header">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <a
                href="#"
                @click.prevent="activeCompany= null"
              >
                {{ $t('changeAccount.hesabDyi') }}
              </a>
            </li>
            <li class="breadcrumb-item">
              {{ activeCompany.name }} {{ getCompanyFormat(activeCompany.format) }}
            </li>
          </ol>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <h4 @click.prevent="activeCompany=null">
            <feather type="arrow-left" />
            {{ activeCompany.name }} {{ getCompanyFormat(activeCompany.format) }}
          </h4>
        </div>


        <div class="col-12 mt-3">
          <div class="card">
            <div class="card-body">
              <div class="row text-secondary mb-4">
                <div class="col-4">
                  {{ $t('header.profil') }}
                </div>
                <div class="col-4">
                  {{ $t('changeAccount.abunlik') }}
                </div>
                <div class="col-4" />
              </div>


              <template v-for="p in profileTypes">
                <hr>
                <div class="row my-3 small ">
                  <div class="col-4 d-flex align-items-center">
                    <ProfileTypeIcon
                      :profile="p"
                      style="height: 50px;"
                    />
                    <strong>{{ getProfileName(p) }} </strong>
                  </div>
                  <div class="col-4  d-flex align-items-center">
                    <CompanyProfilePackageStatus
                      v-if="profileSubscriptions[p]"
                      :user-package="profileSubscriptions[p].userPackage"
                    />
                  </div>
                  <div class="col-4   d-flex align-items-center justify-content-end">
                    <button
                      v-if="p===profile && company.id === activeCompany.id"
                      type="button"
                      class="btn btn-light-success"
                      @click.prevent="changeAccount(activeCompany.id, p, 'company')"
                    >
                      {{ $t('changeAccount.aktiv') }} <i class="fa fa-check" />
                    </button>
                    <button
                      v-else-if="profileSubscriptions[p]"
                      type="button"
                      class="btn btn-light-dark"
                      @click.prevent="changeAccount(activeCompany.id, p, 'company')"
                    >
                      {{ $t('changeAccount.hesabaKe') }} <i class="fa fa-chevron-right" />
                    </button>

                    <router-link
                      v-else
                      type="button"
                      class="btn btn-light-primary"
                      :to="{name: `companyPage`, params:{id: activeCompany.id}}"
                    >
                      {{ $t('changeAccount.profilYarat') }} <i class="fa fa-plus" />
                    </router-link>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="container"
    >
      <div class="page-header">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li class="breadcrumb-item">
              {{ $t('changeAccount.hesabDyi') }}
            </li>
          </ol>
        </div>
      </div>

      <div v-if="companyList.length<1 && !user.personalCompanyCreated">
        <div class="card">
          <div
            class="card-body d-flex align-items-center"
            style="min-height: 70vh"
          >
            <div class="text-center w-100">
              <h3>{{ $t('changeAccount.irktProfili') }}</h3>

              <div class="lead">
                {{ $t('changeAccount.irktiniziQeydiyyatdanKeirinVQeydiyyatnzTamamlayn') }}
              </div>


              <div class="row my-5">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn  btn-light-primary "
                    @click="activatePersonalProfile"
                  >
                    {{ $t('changeAccount.frdiXsKimiDavamEdin') }}
                  </button>
                </div>
                <div class="col-6">
                  <router-link
                    class="btn btn-primary"
                    :to="{name:'companySearch'}"
                  >
                    {{ $t('changeAccount.irktLavEt') }}
                  </router-link>
                </div>
              </div>

              <div>{{ $t('changeAccount.hrHansSualnzVarm') }}</div>
              <div>
                <router-link
                  target="_blank"
                  :to="{name:'page', params:{slug: 'contact'}}"
                >
                  {{ $t('changeAccount.bizimlLaqSaxlayn') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="row"
      >
        <div class="col-8">
          <h4>{{ $t('changeAccount.hesablarm') }}</h4>
        </div>
        <div class="col-4 text-right">
          <router-link
            class="btn btn-primary"
            :to="{name:'companySearch'}"
          >
            {{ $t('changeAccount.irktLavEt') }}
          </router-link>
        </div>


        <div class="col-12 mt-3">
          <div class="card">
            <div class="card-body">
              <div class="row text-secondary mb-4">
                <div class="col-4">
                  {{ $t('changeAccount.hesabnAd') }}
                </div>
                <div class="col-8">
                  {{ $t('changeAccount.profillr') }}
                </div>
              </div>

              <template v-for="c in companyList">
                <hr>
                <div class="row my-3 small">
                  <div class="col-4 d-flex align-items-center">
                    <img
                      :src="getPhoto(c.logo,'mediumCropped')"
                      :alt="`${user.name}`"
                      class="img-fluid rounded-circle shadow mr-2"
                      style="height: 50px;"
                    >
                    <div>
                      <strong>{{ c.name }} {{ getCompanyFormat(c.format) }} </strong>
                      <br><span>{{ c.taxId }}</span>
                    </div>
                  </div>
                  <div class="col-7   d-flex align-items-center flex-wrap">
                    <ProfileTypeBadge
                      v-for="p in companyProfiles(c.id)"
                      class="m-1 cursor-pointer"
                      :is-current=" company && c.id===company.id && p.profileType===profile"
                      :profile="p.profileType"
                      :badge-white="false"
                      @clicked="changeAccount(c.id, p.profileType, 'company')"
                    />
                  </div>

                  <div class="col-1   d-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-dark py-2"
                      @click.prevent="activeCompany=c"
                    >
                      {{ $t('changeAccount.ayarlar') }}
                    </button>
                  </div>
                </div>
              </template>

              <template v-if="!user.personalCompanyCreated">
                <div
                  class="row my-3 small cursor-pointer"
                  @click.prevent="changeAccount(0, '', 'personal')"
                >
                  <div class="col-4 d-flex align-items-center">
                    <img
                      :src="getPhoto(user.photo,'mediumCropped')"
                      :alt="`${user.name}`"
                      class="img-fluid rounded-circle shadow mr-2"
                      style="height: 50px;"
                    >
                    <div>
                      <strong>{{ user.name }} {{ user.surname }} </strong>

                      <br>
                      <span>{{ $t('changeAccount.fin', {uniqueId: user.uniqueId}) }}</span>
                    </div>
                  </div>
                  <div class="col-6 d-flex align-items-center">
                    <span class="badge bg-success">{{ $t('changeAccount.frdiXs') }}</span>
                  </div>
                  <div class="col-2   d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-dark py-2"
                      @click="activatePersonalProfile"
                    >
                      {{ $t('changeAccount.aktivldir') }}
                    </button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {userAccounts, userSetAccount} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileIcon, getProfileName} from "@/repositories/Utils";
import CompanyProfilePackageStatus from "@/pages/scc/company/CompanyProfilePackageStatus.vue";
import ProfileTypeBadge from "@/components/ProfileTypeBadge.vue";
import {CompanyProfileType} from "@/repositories/Enums";
import ProfileTypeIcon from "@/components/ProfileTypeIcon.vue";


export default {
  components: {ProfileTypeIcon, ProfileTypeBadge, CompanyProfilePackageStatus},
  data() {
    return {
      mediaBase: mediaBase,
      profiles: [],
      activeCompany: null,
      profileTypes: [
        CompanyProfileType.PROCUREMENT,
        CompanyProfileType.SUPPLIER,
        CompanyProfileType.LOGISTIC,
        CompanyProfileType.TRUCK,
      ]
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),

    profileSubscriptions() {

      let map = {};
      if (this.activeCompany) {
        this.companyProfiles(this.activeCompany.id).forEach(p => {
          if (this.profileTypes.indexOf(p.profileType) !== -1) {
            map[p.profileType] = p;
          }
        });
      }
      return map;
    },

    companyList() {

      let idList = [];
      let list = [];

      this.profiles.forEach(p => {
        if (idList.indexOf(p.company.id) === -1) {
          idList.push(p.company.id);
          list.push(p.company);
        }
      })

      return list;

    },

  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then(data => {
        this.profiles = data;
      });
    }
  },
  mounted() {

    userAccounts(this.token).then(data => {
      this.profiles = data;
    });
  },
  methods: {
    companyProfiles(companyId) {
      let list = [];
      this.profiles.forEach(p => {
        if (p.company.id === companyId) {
          list.push(p);
        }
      })
      return list;
    },


    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    }, getProfileIcon(keyword) {
      return getProfileIcon(keyword);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    changeAccount(companyId, profileType, accountType) {
      userSetAccount(this.token, companyId, profileType, accountType).then(data => {

        if (data.code === 200) {

          let next = this.$route.query['next'] || '/dashboard/welcome';
          this.$router.replace(next);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            //window.location.reload();
          })
        }

      })
    },
    activatePersonalProfile(){
      this.$swal.fire({
        title: this.$t("changeAccount.frdiXsKimiDavamEdin"),
        text: this.$t("personalCompanyActivate.frdiXsProfilininSlahiyytlriMhduddurFunksiyalardanD"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: this.$t("changeAccount.frdiXsKimiDavamEdin"),
        cancelButtonText: this.$t("companyProfile.lvEt")
      }).then((result) => {
        if (result.isConfirmed) {
            this.$router.push({name: 'companyPersonalCreate'});
        }
      })
    }

  }

}
</script>
<style>
.cursor-enabled {
  cursor: pointer;
}
</style>
